import {Component, HostListener, Input, ViewEncapsulation} from '@angular/core';
import {VoiceRecognitionService} from './voice-recognition.service';
import {
    DialogConfigTextInputValidation
} from 'botato-botengine-browser/botato/botato-botengine/source/Core/DialogConfig/DialogConfig.js';

@Component({
    selector: 'botato-text-voice-input',
    templateUrl: './voice-input.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class VoiceInputComponent {

    @Input() inputTextValidation: DialogConfigTextInputValidation | undefined;

    constructor(public voiceService: VoiceRecognitionService) {
    }

    @HostListener('touchstart')
    public onTouchStart(): void {
        this.startVoice();
    }

    @HostListener('touchend')
    public onTouchEnd(): void {
        this.stopVoice();
    }

    @HostListener('touchcancel')
    public onTouchCancel(): void {
        this.stopVoice();
    }


    public startVoice(): void {
        this.voiceService.recordedVoice.next(true);
        this.voiceService.start(this.inputTextValidation);
    }

    public stopVoice(): void {
        this.voiceService.stop();
        this.voiceService.recordedVoice.next(false);
    }
}
